<template>
  <div>
    <template v-if="type=='bar'">
      <div :class="outerClasses">
        <div :class="innerClasses">
          <div :class="bgClasses" :style="bgStyle"></div>
        </div>
        <div v-if="!hideInfo" :class="textClasses">
          <slot>
            <template v-if="isStatus">
              <t-icon :type="statusIcon"></t-icon>
            </template>
            <template v-else>
              {{ percentTxt }}%
            </template>
          </slot>
        </div>
      </div>
    </template>
    <template v-if="type=='circle'">
      <div :class="circleClasses">
        <svg :style="svgStyle">
          <circle :cx="circleOpt.cx" :cy="circleOpt.cy" :r="circleOpt.r" :style="circleStyleOut" fill="none" class="progress-circle__bg"></circle>
          <circle :cx="circleOpt.cx" :cy="circleOpt.cy" :r="circleOpt.r" :style="circleStyle" :class="{'invisible': !percentTxt}" fill="none" class="progress-circle__bar"></circle>
        </svg>
        <div v-if="!hideInfo" class="progress-circle__text">
          <span class="progress-circle__percent">
            <slot>
              <template v-if="isStatus">
                <t-icon :type="statusIcon"></t-icon>
              </template>
              <template v-else>
                {{ percentTxt }}%
              </template>
            </slot>
          </span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
/* eslint-disable no-extra-boolean-cast */

const PREFIXCLS = 'progress'
export default {
  props: {
    percent: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      validator(value) {
        return ['bar', 'circle'].includes(value)
      },
      default: 'bar'
    },
    status: {
      type: String,
      validator(value) {
        return ['normal', 'active', 'exception', 'success'].includes(value)
      },
      default: 'normal'
    },
    hideInfo: {
      type: Boolean,
      default: false
    },
    strokeWidth: {
      type: Number
    },
    circleOption: {
      // 定制圆形属性
      type: Object
    },
    size: {
      type: String,
      validator(value) {
        return ['sm', 'md', 'lg'].includes(value)
      },
      default: 'md'
    }
  },
  data() {
    return {
      currentStatus: this.status
    }
  },
  computed: {
    percentTxt () {
      if (Number.isInteger(this.percent)) {
        return this.percent
      } else {
        return 0
      }
    },
    isStatus() {
      return (
        this.currentStatus === 'exception' || this.currentStatus === 'success'
      )
    },
    statusIcon() {
      let type = ''
      if (this.type !== 'circle') {
        switch (this.currentStatus) {
          case 'exception':
            type = 'close-circle'
            break
          case 'success':
            type = 'check-circle'
            break
        }
      } else {
        switch (this.currentStatus) {
          case 'exception':
            type = 'close'
            break
          case 'success':
            type = 'check'
            break
        }
      }
      return type
    },
    circleOpt() {
      if (this.type !== 'circle') return 0
      // 定制参数不为空，使用定制参数
      if (this.circleOption) {
        return this.circleOption
      }
      let circleOpt = {}
      const _size = {
        'lg': [100, 100, 90],
        'md': [40, 40, 36],
        'sm': [20, 20, 18]
      }
      let [cx = 0, cy = 0, r = 0] = _size[this.size]
      circleOpt.cx = cx
      circleOpt.cy = cy
      circleOpt.r = r
      return circleOpt
    },
    circleStyleOut() {
      return {
        'stroke-width': `${this.strokeWidth}px`
      }
    },
    circleStyle() {
      let pe = 2 * Math.PI * this.circleOpt.r
      let cp = pe * this.percent / 100
      return {
        'stroke-dasharray': cp + ',' + pe * 2,
        'stroke-width': `${this.strokeWidth}px`
      }
    },
    bgStyle() {
      if (!!this.strokeWidth) {
        return {
          width: `${this.percent}%`,
          height: `${this.strokeWidth}px`
        }
      } else {
        return {
          width: `${this.percent}%`
        }
      }
    },
    svgStyle() {
      if (!!this.circleOption) {
        return {
          width: `${this.circleOption.cx * 2}px`,
          height: `${this.circleOption.cx * 2}px`
        }
      }
    },
    textClasses() {
      return [
        `${PREFIXCLS}-text`,
        {
          [`text-success`]: this.currentStatus === 'success',
          [`text-danger`]: this.currentStatus === 'exception',
          [`${PREFIXCLS}--` + this.size]: !!this.size
        }
      ]
    },
    outerClasses() {
      return [`${PREFIXCLS}-outer`]
    },
    innerClasses() {
      return [
        `${PREFIXCLS}`,
        {
          [`${PREFIXCLS}--` + this.size]: !!this.size,
          [`${PREFIXCLS}--active`]: this.currentStatus === 'active'
        }
      ]
    },
    bgClasses() {
      return [
        `${PREFIXCLS}-${this.type}`,
        {
          [`bg-primary`]:
            this.currentStatus === 'normal' || this.currentStatus === 'active',
          [`bg-danger`]: this.currentStatus === 'exception',
          [`bg-success`]: this.currentStatus === 'success'
        }
      ]
    },
    circleClasses() {
      return [
        `${PREFIXCLS}-${this.type}`,
        {
          [`${PREFIXCLS}-${this.type}--` + this.size]: !!this.size,
          [`${PREFIXCLS}-${this.type}--primary`]:
            this.currentStatus === 'normal' || this.currentStatus === 'active',
          [`${PREFIXCLS}-${this.type}--danger`]:
            this.currentStatus === 'exception',
          [`${PREFIXCLS}-${this.type}--success`]:
            this.currentStatus === 'success'
        }
      ]
    }
  },
  watch: {
    percent(val, oldVal) {
      if (val < oldVal) {
        this.$_onStatusChange(true)
      } else {
        this.$_onStatusChange()
      }
    },
    status(val) {
      this.currentStatus = val
    }
  },
  created() {
    this.$_onStatusChange()
  },
  methods: {
    // 设置为私有方法
    $_onStatusChange(isDown) {
      if (isDown) {
        this.currentStatus = 'normal'
        this.$emit('on-status-change', 'normal')
      } else {
        if (parseInt(this.percent, 10) === 100) {
          this.currentStatus = 'success'
          this.$emit('on-status-change', 'success')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// progress.vue?261116ba